import {
  assetPricesPayloadSchema,
  type AssetPricesPayload,
  type AssetRelationType,
} from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { PriceEditor } from '~/components/assets/PriceEditor'
import { PhaseWrapper } from '~/components/flows/phases/PhaseWrapper.tsx'
import { ViewTitle } from '~/components/layout/Sections.tsx'

export const pricingSchema = assetPricesPayloadSchema

export type PricingData = AssetPricesPayload

export interface PricingPhaseProps {
  relationType: AssetRelationType
  priceValues: PricingData
  onUpdateData: (data: PricingData) => void
}

export function PricingPhase({ relationType, priceValues, onUpdateData }: PricingPhaseProps) {
  const isProspect = relationType === 'prospect'
  const { t } = useTranslations('property')

  const prices: AssetPricesPayload = {
    displayPrice: priceValues.displayPrice ?? 0,
    finalPrice: priceValues.finalPrice,
  }

  return (
    <PhaseWrapper>
      <ViewTitle>
        {t(($) => (isProspect ? $.flow.pricing.title.prospect : $.flow.pricing.title.other))}
      </ViewTitle>
      <View className="flex-1 gap-8">
        <PriceEditor
          data={prices}
          relationType={relationType}
          onUpdate={onUpdateData}
          variant="default"
        />
      </View>
    </PhaseWrapper>
  )
}
